import { Instance } from '@ui/interfaces'
import { useNavigationStateStore } from '@ui/stores'
import Cookies from 'universal-cookie'
import { create } from 'zustand'

const cookies = new Cookies()

const savedSelectedInstance = cookies.get('selected_instance_key')
const initialSelectedInstance = savedSelectedInstance ? savedSelectedInstance : null

interface State {
  instances: Instance[]
  selectedInstanceKey: string | null
  getSelectedInstanceName: () => string | null
  resetStore: () => void
}

interface Actions {
  setInstances: (instances: Instance[]) => void
  setSelectedInstanceKey: (selectedInstanceKey: string) => void
  resetStore: () => void
}

export const useInstanceStore = create<State & Actions>((set, get) => ({
  // State
  instances: [],
  selectedInstanceKey: initialSelectedInstance,
  getSelectedInstanceName: () => {
    const selectedInstance = get().instances.find((i) => i.connect_key)
    return selectedInstance ? selectedInstance.name : null
  },

  // Actions
  setInstances: (instances) => set({ instances }),
  setSelectedInstanceKey: (selectedInstanceKey) => {
    // Cookie is used to verify reverse proxy requests from the UI
    const cookieDomain = window.location.hostname.endsWith('datable.io') ? '.datable.io' : ''
    cookies.set('selected_instance_key', selectedInstanceKey, { path: '/', domain: cookieDomain })
    useNavigationStateStore.getState().setParams({ instanceId: selectedInstanceKey })
    set({ selectedInstanceKey })
  },
  resetStore: () => {
    set({ instances: [], selectedInstanceKey: null })
    cookies.remove('selected_instance_key')
  },
}))
